"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../utils/routes");
const index_1 = require("../index");
function JoinNotification({ notification, onSelect, selected, }) {
    const { identifier, group, user } = notification;
    const { name: groupName } = group;
    const { name: userName } = user;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const description = ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.join), " ", groupName] }));
    const action = () => {
        navigate(routes_1.Routes.Sharing);
    };
    return ((0, jsx_runtime_1.jsx)(index_1.Notification, { notification: notification, onSelect: onSelect, selected: selected, description: description, title: userName, important: true, isGroup: true, buttons: [
            {
                identifier,
                action: () => { },
                icon: ui_1.Icons.Cross,
                type: index_1.ButtonType.Flat,
                title: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.ignore),
            },
            {
                action,
                identifier,
                icon: ui_1.Icons.Group_Edit,
                type: index_1.ButtonType.Secondary,
                title: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.editGroup),
            },
        ], "data-e2e": 'JoinNotification_Notification' }));
}
exports.default = JoinNotification;
